import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0129',
    ecrans: ['00-2']
});
